/* RG brändisektiot: paljastukset, hero-koreografia, laskurit, klikkaa-toistaaksesi-videot. Suojattu monikertaista latausta vastaan. */
(function () {
  if (window.rgBrandInit) return;
  window.rgBrandInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    // Hero: otsikkorivit ja kuva sisään
    document.querySelectorAll('.rgb--hero').forEach(function (h) {
      requestAnimationFrame(function () { setTimeout(function () { h.classList.add('is-ready'); }, 60); });
    });
    document.querySelectorAll('[data-rgb-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sec = b.closest('.rgb');
        var next = sec && sec.parentElement ? sec.parentElement.nextElementSibling : null;
        (next || document.body).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // Paljastukset
    var items = document.querySelectorAll('.rgb-reveal');
    if (!('IntersectionObserver' in window) || reduce) { items.forEach(function (el) { el.classList.add('is-in'); }); }
    else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      var vh = window.innerHeight || 800;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        // Jo näkymässä oleva sisältö ei piiloudu (LCP ei odota skriptiä); muut piilotetaan ja paljastetaan vierittäessä
        if (r.top < vh && r.bottom > 0) { el.classList.add('is-in'); return; }
        el.classList.add('rgb-reveal--armed'); io.observe(el);
      });
    }

    // Laskurit
    var counters = document.querySelectorAll('[data-rgb-count]');
    function runCounter(el) {
      var target = parseFloat(el.getAttribute('data-rgb-count'));
      var decimals = (el.getAttribute('data-rgb-decimals') || '0') | 0;
      var dur = 1400, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur); p = 1 - Math.pow(1 - p, 3);
        var v = target * p;
        el.textContent = v.toFixed(decimals).replace('.', ',');
        if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(decimals).replace('.', ',');
      }
      requestAnimationFrame(step);
    }
    if (counters.length) {
      if (!('IntersectionObserver' in window) || reduce) { counters.forEach(function (el) { el.textContent = el.getAttribute('data-rgb-count').replace('.', ','); }); }
      else {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { runCounter(e.target); cio.unobserve(e.target); } });
        }, { threshold: 0.4 });
        counters.forEach(function (el) { cio.observe(el); });
      }
    }


    // Etusivun brändivaihdin
    document.querySelectorAll('[data-rgb-hh]').forEach(function (stage) {
      var root = stage.closest('.rgb');
      var slides = stage.querySelectorAll('[data-rgb-hh-slide]'), tabs = stage.querySelectorAll('[data-rgb-hh-tab]');
      var bgs = root ? root.querySelectorAll('[data-rgb-hh-bg]') : [];
      var interval = (parseInt(stage.getAttribute('data-interval'), 10) || 6) * 1000;
      root && root.style.setProperty('--rgb-hh-interval', (interval / 1000) + 's');
      var i = 0, timer = null, n = slides.length;
      if (!n) return;
      var narrow = window.matchMedia('(max-width: 989px)');
      function hydrate(el) { if (!el) return; if (el.hasAttribute('data-rgb-hh-bg') && narrow.matches) return; el.querySelectorAll('img[data-src]').forEach(function (im) { im.srcset = im.getAttribute('data-srcset') || ''; im.sizes = im.getAttribute('data-sizes') || ''; im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }); }
      function show(k) {
        i = (k + n) % n;
        hydrate(slides[i]); hydrate(bgs[i]); hydrate(slides[(i + 1) % n]); hydrate(bgs[(i + 1) % n]);
        slides.forEach(function (s, j) { var on = j === i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); s.tabIndex = on ? 0 : -1; });
        tabs.forEach(function (t, j) { var on = j === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) { var bar = t.querySelector('.rgb-hh__bar'); if (bar) { bar.style.display = 'none'; void bar.offsetWidth; bar.style.display = ''; } } });
        bgs.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      }
      var userPaused = false;
      function start(force) { if (force) { userPaused = false; root && root.classList.remove('is-paused'); } if (reduce || n < 2 || userPaused) return; stop(); timer = setInterval(function () { show(i + 1); }, interval); }
      function stop(force) { if (force) { userPaused = true; root && root.classList.add('is-paused'); } if (timer) { clearInterval(timer); timer = null; } }
      stage.__rgbHH = { start: function () { start(true); }, stop: function () { stop(true); } };
      tabs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); start(); }); });
      stage.addEventListener('mouseenter', function () { stop(); root && root.classList.add('is-paused'); });
      stage.addEventListener('mouseleave', function () { root && root.classList.remove('is-paused'); start(); });
      stage.addEventListener('focusin', function () { stop(); root && root.classList.add('is-paused'); });
      stage.addEventListener('focusout', function () { root && root.classList.remove('is-paused'); start(); });
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      show(0); start();
    });


    // Tuotekuvauksen toimituksellinen esitys: johdanto, ominaisuuslista, osionavigaatio, annostelunosto, taulukot
    var marker = document.querySelector('[data-rgv-desc]');
    var desc = marker && document.querySelector('.product__description');
    if (desc && !desc.classList.contains('rgv-desc')) {
      desc.classList.add('rgv-desc');
      document.body.classList.add('rgv-page');
      // Normalisoi sähköpostista liitetty div-pohjainen markup kappaleiksi: puretaan lohkoja sisältävät divit, muut divit → p, tyhjät pois
      (function normalize(root) {
        var changed = true, guard = 0;
        while (changed && guard++ < 50) {
          changed = false;
          Array.prototype.slice.call(root.childNodes).forEach(function (el) {
            if (el.nodeType === 3) { if (el.textContent.trim()) { var p0 = document.createElement('p'); p0.textContent = el.textContent.trim(); root.replaceChild(p0, el); changed = true; } else root.removeChild(el); return; }
            if (el.nodeType !== 1) return;
            if (el.tagName === 'BR' || (!el.textContent.trim() && !el.querySelector('img,table'))) { el.remove(); changed = true; return; }
            if (el.tagName === 'DIV' || el.tagName === 'SPAN' || el.tagName === 'SECTION') {
              if (el.querySelector('p,ul,ol,table,h1,h2,h3,h4,div,section')) { while (el.firstChild) root.insertBefore(el.firstChild, el); el.remove(); }
              else { var p1 = document.createElement('p'); p1.innerHTML = el.innerHTML; root.replaceChild(p1, el); }
              changed = true;
            }
          });
        }
      })(desc);
      var nodes = Array.prototype.slice.call(desc.childNodes).filter(function (n) { return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim()); });
      var lead = document.createElement('div'); lead.className = 'rgv-lead';
      var sections = [], cur = null;
      nodes.forEach(function (n) {
        var isH = n.nodeType === 1 && /^H[1-4]$/.test(n.tagName);
        if (isH) { cur = { title: n.textContent.trim(), h: n, body: [] }; sections.push(cur); }
        else if (cur) cur.body.push(n); else lead.appendChild(n);
      });
      // Otsikoton kuvaus: lihavoitu "Ominaisuudet:"-rivi + lista → ominaisuuskortti
      if (!sections.length) {
        var kids = Array.prototype.slice.call(lead.children);
        for (var k = 0; k < kids.length - 1; k++) {
          if (/ominaisuudet/i.test(kids[k].textContent) && kids[k].textContent.trim().length < 40 && kids[k + 1].tagName === 'UL') {
            sections.push({ title: kids[k].textContent.replace(/:\s*$/, '').trim(), body: [kids[k + 1]] }); kids[k].remove(); break;
          }
        }
      }
      var firstP = Array.prototype.slice.call(lead.children).filter(function (el) { return el.tagName === 'P' && el.textContent.trim().length > 80; })[0];
      if (firstP) firstP.classList.add('rgv-lead__first');
      desc.innerHTML = '';
      if (lead.childNodes.length) desc.appendChild(lead);
      var featIdx = -1;
      sections.forEach(function (sec, i) { var hasUl = sec.body.some(function (b) { return b.tagName === 'UL'; }); if (!hasUl) return; if (/^t[äa]rkeimm[äa]t/i.test(sec.title)) featIdx = i; else if (featIdx === -1 && /^ominaisuudet$/i.test(sec.title)) featIdx = i; });
      if (featIdx > -1) {
        var f = sections.splice(featIdx, 1)[0], ul = f.body.filter(function (b) { return b.tagName === 'UL'; })[0];
        var card = document.createElement('div'); card.className = 'rgv-features';
        var ht = document.createElement('p'); ht.className = 'rgv-features__title'; ht.textContent = f.title; card.appendChild(ht);
        ul.className = 'rgv-features__list'; card.appendChild(ul); desc.appendChild(card);
      }
      var doseSec = sections.filter(function (s) { return /annostel|käyttö/i.test(s.title); })[0];
      if (doseSec) {
        var dosePara = doseSec.body.filter(function (b) { return b.tagName === 'P' && /\d+\s?(ml|dl|l|g|kpl|korkki)\b/i.test(b.textContent) && /(litra|vet|kastel|viiko|kuukau)/i.test(b.textContent); })[0];
        if (dosePara) {
          var dose = document.createElement('aside'); dose.className = 'rgv-dose';
          dose.innerHTML = '<span class="rgv-dose__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/></svg></span><div><p class="rgv-dose__label">Annostelu</p><p class="rgv-dose__text"></p></div>';
          dose.querySelector('.rgb-dose__text, .rgv-dose__text').textContent = dosePara.textContent.trim();
          desc.appendChild(dose);
        }
      }
      if (sections.length > 1) {
        var nav = document.createElement('nav'); nav.className = 'rgv-secnav'; nav.setAttribute('aria-label', 'Tuotekuvauksen osiot');
        sections.forEach(function (sec, i) { var id = 'osio-' + (i + 1); sec.id = id; var a = document.createElement('a'); a.href = '#' + id; a.textContent = sec.title; nav.appendChild(a); });
        desc.appendChild(nav);
      }
      sections.forEach(function (sec, i) {
        var wrap = document.createElement('section'); wrap.className = 'rgv-sec'; wrap.id = sec.id || ('osio-' + (i + 1));
        var h = document.createElement('h2'); h.className = 'rgv-sec__title'; h.textContent = sec.title; wrap.appendChild(h);
        sec.body.forEach(function (b) {
          if (b.tagName === 'TABLE') { var tw = document.createElement('div'); tw.className = 'rgv-table'; tw.appendChild(b); wrap.appendChild(tw); }
          else wrap.appendChild(b);
        });
        desc.appendChild(wrap);
      });
    }

    // Kokoelmahero sisältää oman murupolun → piilota teeman yleinen murupolku
    var chero = document.querySelector('.rgb-chero');
    if (chero) {
      document.querySelectorAll('.rg-crumbs').forEach(function (c) { c.hidden = true; });
      var host = chero.closest('.rgb') || chero, cs = getComputedStyle(host);
      document.body.classList.add('rgb-collection');
      document.body.style.setProperty('--rgb-page-accent', cs.getPropertyValue('--rgb-accent').trim() || '#C96F4A');
      document.body.style.setProperty('--rgb-page-accent-rgb', cs.getPropertyValue('--rgb-accent-rgb').trim() || '201,111,74');
    }

    // Hero-taustavideo: ladataan vasta sivun latauduttua ja kun hero on näkyvissä (ei Data Saver -tilassa)
    (function () {
      var vids = document.querySelectorAll('video[data-rgb-lazy-video]');
      if (!vids.length || reduce) return;
      var conn = navigator.connection || {};
      if (conn.saveData || /(^|[^a-z])2g/.test(conn.effectiveType || '')) return;
      function attach(v) {
        if (v.getAttribute('src')) return;
        // Liquid tarjoaa vain parhaan mp4:n; Shopify tuottaa myös 720p/480p-versiot samalla nimikaavalla → johdetaan URL, virheessä palataan alkuperäiseen
        var orig = v.getAttribute('data-rgb-lazy-video');
        var want = window.matchMedia('(max-width: 749px)').matches ? 'SD-480p-1.5Mbps' : 'HD-720p-4.5Mbps';
        var derived = orig.replace(/\.(HD|SD)-\d+p-[\d.]+Mbps-/, '.' + want + '-');
        var tried = false;
        v.addEventListener('error', function () { if (!tried && v.src !== orig) { tried = true; v.src = orig; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); } });
        v.src = derived; v.muted = true; v.autoplay = true;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      function arm() {
        if ('IntersectionObserver' in window) {
          var vio = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { attach(e.target); vio.unobserve(e.target); } }); }, { rootMargin: '200px' });
          vids.forEach(function (v) { vio.observe(v); });
        } else vids.forEach(attach);
      }
      if (document.readyState === 'complete') setTimeout(arm, 300); else window.addEventListener('load', function () { setTimeout(arm, 300); });
    })();

    // Hotspot-miljöökuva: piste ⇄ tuotekortti korostavat toisiaan; klikkaus/Enter lukitsee, Esc vapauttaa
    document.querySelectorAll('[data-rgb-hotspots]').forEach(function (root) {
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rgb-hs]'));
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rgb-hs-card]'));
      function card(i) { return cards.filter(function (c) { return c.getAttribute('data-rgb-hs-card') === String(i); })[0]; }
      function dot(i) { return dots.filter(function (d) { return d.getAttribute('data-rgb-hs') === String(i); })[0]; }
      function hover(i, on) { var c = card(i), d = dot(i); if (c) c.classList.toggle('is-hover', on); if (d) d.classList.toggle('is-hover', on); }
      function lock(i) {
        dots.forEach(function (d) { var on = d.getAttribute('data-rgb-hs') === String(i); d.classList.toggle('is-active', on); d.setAttribute('aria-expanded', on ? 'true' : 'false'); });
        cards.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-rgb-hs-card') === String(i)); });
        var c = card(i);
        if (c && window.matchMedia('(max-width: 989px)').matches) c.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
      dots.forEach(function (d) {
        var i = d.getAttribute('data-rgb-hs');
        d.addEventListener('click', function () { lock(d.classList.contains('is-active') ? -1 : i); });
        d.addEventListener('mouseenter', function () { hover(i, true); });
        d.addEventListener('mouseleave', function () { hover(i, false); });
        d.addEventListener('focus', function () { hover(i, true); });
        d.addEventListener('blur', function () { hover(i, false); });
      });
      cards.forEach(function (c) {
        var i = c.getAttribute('data-rgb-hs-card');
        c.addEventListener('mouseenter', function () { hover(i, true); });
        c.addEventListener('mouseleave', function () { hover(i, false); });
        c.addEventListener('focusin', function () { hover(i, true); });
        c.addEventListener('focusout', function () { hover(i, false); });
      });
      root.addEventListener('keydown', function (e) { if (e.key === 'Escape') lock(-1); });
    });

    // Tarina vierittäen: keskellä näkymää oleva vaihe vaihtaa kiinnittyvän kuvan
    document.querySelectorAll('[data-rgb-scrolly]').forEach(function (root) {
      var steps = root.querySelectorAll('[data-rgb-sc-step]'), imgs = root.querySelectorAll('[data-rgb-sc-img]'), cur = root.querySelector('[data-rgb-sc-cur]');
      function act(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        if (cur) cur.textContent = ('0' + (i + 1)).slice(-2);
      }
      if (!steps.length) return;
      if (!('IntersectionObserver' in window)) { steps.forEach(function (s) { s.classList.add('is-active'); }); if (imgs[0]) imgs[0].classList.add('is-active'); return; }
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) act(parseInt(e.target.getAttribute('data-rgb-sc-step'), 10)); });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      steps.forEach(function (s) { sio.observe(s); });
      act(0);
    });

    // Ruukkuvalitsin: muoto/leveys/korkeus suodattavat mallikortit (mittahaarukan päällekkäisyys)
    document.querySelectorAll('[data-rgb-picker]').forEach(function (root) {
      var state = { shape: '', w: '', h: '' };
      var cards = Array.prototype.slice.call(root.querySelectorAll('.rgb-pk__card')), status = root.querySelector('[data-pk-status]');
      function inRange(min, max, range) { if (!range) return true; if (isNaN(min) || isNaN(max)) return true; var p = range.split('-').map(Number); return max >= p[0] && min <= p[1]; }
      function apply() {
        var n = 0;
        cards.forEach(function (c) {
          var ok = (!state.shape || c.getAttribute('data-pk-shape') === state.shape) &&
            inRange(parseFloat(c.getAttribute('data-pk-wmin')), parseFloat(c.getAttribute('data-pk-wmax')), state.w) &&
            inRange(parseFloat(c.getAttribute('data-pk-hmin')), parseFloat(c.getAttribute('data-pk-hmax')), state.h);
          var was = !c.classList.contains('is-hidden');
          c.classList.toggle('is-hidden', !ok);
          if (ok) { n++; if (!was && !reduce) { c.classList.remove('is-in'); void c.offsetWidth; c.classList.add('is-in'); } }
        });
        if (status) status.textContent = n ? (root.getAttribute('data-l-count') || '{n}').replace('{n}', n) : (root.getAttribute('data-l-empty') || '');
      }
      root.querySelectorAll('[data-pk-group]').forEach(function (g) {
        var key = g.getAttribute('data-pk-group');
        g.addEventListener('click', function (e) {
          var b = e.target.closest('[data-pk]'); if (!b) return;
          state[key] = b.getAttribute('data-pk') || '';
          g.querySelectorAll('[data-pk]').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          apply();
        });
      });
    });

    // Pysäytä/jatka-painikkeet (WCAG 2.2.2): hero-video, etusivun brändivaihdin, logonauha
    document.querySelectorAll('[data-rgb-pause]').forEach(function (btn) {
      var kind = btn.getAttribute('data-rgb-pause'), paused = false;
      var host = btn.closest('.rg-marquee, .eco-hero, .rgb, .shopify-section') || document.body;
      function render() {
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.classList.toggle('is-paused', paused);
        var t = btn.querySelector('span'); if (t) t.textContent = paused ? btn.getAttribute('data-l-play') : btn.getAttribute('data-l-pause');
      }
      btn.addEventListener('click', function () {
        paused = !paused;
        if (kind === 'video') { var v = host.querySelector('video'); if (v) { if (paused) v.pause(); else { var p = v.play(); if (p && p.catch) p.catch(function () {}); } } }
        else if (kind === 'marquee') { host.classList.toggle('is-paused', paused); }
        else if (kind === 'hh') { var st = host.querySelector('[data-rgb-hh]'); if (st && st.__rgbHH) { paused ? st.__rgbHH.stop() : st.__rgbHH.start(); } }
        render();
      });
    });

    // Videot: klikkaa toistaaksesi (YouTube nocookie)
    document.querySelectorAll('[data-rgb-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-rgb-video');
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        f.title = btn.getAttribute('aria-label') || 'Video';
        btn.innerHTML = '';
        btn.appendChild(f);
        btn.style.cursor = 'default';
      }, { once: true });
    });
  });
})();
